import { render, staticRenderFns } from "./CMenuMb.vue?vue&type=template&id=48f463a2&"
import script from "./CMenuMb.vue?vue&type=script&lang=ts&"
export * from "./CMenuMb.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports